<template>
    <div class="payment-hero__slider bg-cover" :style="bgImg" id="home">
            <div class="container-fluid container-fluid--cp-150 ">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="payment-hero-hero__content  section-space--mt_30">
                            <div class="row">
                                <div class="col-lg-5 wow move-up">
                                    <div class="payment-hero__text">
                                        <!-- <h1>The world's top secure payment platform </h1> -->
                                        <h1>A store in your hand in 9 minutes </h1>
                                        <p class="text-hero section-space--mb_40">Everything you need to sell online. Try it free for 14 days. </p>
                                        <div class="hero-btn-wrap">
                                            <router-link to="/login" class="btn btn--green text-white">Get Started</router-link>
                                            <!-- <h6 class="sub-heading">Questions? 
                                                <router-link to="" class="hover-style-link hover-style-link--green">Talk to our team</router-link>
                                            </h6> -->
                                        </div>

                                    </div>
                                </div>
                                <div class="col-lg-7 wow move-up">
                                    <div class="payment-hero--images__midea">
                                        <img src="@/assets/static-img/hero/payments/landing-img.png" alt="hero thumb" class="img-fluid">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    export default {
        data (){
            return {
                bgImg: {
                    backgroundImage: `url(${require('@/assets/static-img/hero/payments/aeroland-payment-hero-bg-pink.jpg')})`
                }
            }
        }
    }
</script>
